import { render } from "./AllCityMaster.vue?vue&type=template&id=8cb8a28e&scoped=true"
import script from "./AllCityMaster.vue?vue&type=script&lang=js"
export * from "./AllCityMaster.vue?vue&type=script&lang=js"

import "./AllCityMaster.vue?vue&type=style&index=0&id=8cb8a28e&scoped=true&lang=css"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb8a28e"]])

export default __exports__